function getStyle(n, p) {
    return n.currentStyle ? n.currentStyle[p] : document.defaultView.getComputedStyle(n, null).getPropertyValue(p);
}

function toText(node) {
    let result = '';

    if(node.nodeType === document.TEXT_NODE) {
        result = node.nodeValue.replace(/\s+/g, ' ');
    } else {
        for(let i = 0, j = node.childNodes.length; i < j; i++) {
            result += toText(node.childNodes[i]);
        }

        let d = getStyle(node, 'display');

        if(d.match(/^block/) || d.match(/list/) || d.match(/row/) || node.tagName === 'BR' || node.tagName === 'HR') {
            result += '\n';
        }
    }

    return result;
}

export default {
    toText: toText,
};



// WEBPACK FOOTER //
// ./src/utils/DomUtils.js